import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import BookmarkAddOutlined from "@mui/icons-material/BookmarkAddOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { $getSelection } from "lexical";
import { useCallback } from "react";
import { imageURL } from "../../../../design-huddle/utils";
import { $isDesignHuddleNodeMui } from "../../nodes/design-huddle-mui";
import { $isImageNodeMui } from "../../nodes/image-node-mui";

import type { EditorModalState } from "../../lexical-context";
import type { FC } from "react";

export const SaveImageButton: FC<{
  disabled?: boolean;
  handleOpen: (data: EditorModalState) => void;
  mode?: "toolbar" | "floating";
}> = ({ disabled, handleOpen, mode = "floating" }) => {
  const [editor] = useLexicalComposerContext();

  const onClick = useCallback(() => {
    editor.getEditorState().read(() => {
      const selection = $getSelection();
      const node = selection?.getNodes()[0];
      if ($isImageNodeMui(node)) {
        fetch(node.__url, { method: "HEAD" })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Failed to fetch image`);
            }

            const mimeType = response.headers.get("Content-Type");
            mimeType &&
              handleOpen({
                type: "image",
                data: { url: node.__url, mimeType, name: "" },
              });
          })
          .catch(console.error);
      } else if ($isDesignHuddleNodeMui(node) && node.__id) {
        handleOpen({
          type: "design-huddle",
          data: {
            url: imageURL(node.__account_id, node.__id),
            projectId: node.__id,
            name: "",
          },
        });
      }
    });
  }, [editor, handleOpen]);

  return (
    <Tooltip title="Save Image to Content Library">
      <IconButton
        data-analytics-id={`lexical-${mode}-save-to-content-library`}
        data-testid={`${mode}-button-save-to-content-library`}
        disabled={disabled}
        onClick={onClick}
      >
        <BookmarkAddOutlined />
      </IconButton>
    </Tooltip>
  );
};
